import type { RpcOption } from 'mode-shared/types/rpcs';

export const AVAILABLE_RPC: Record<string, RpcOption[]> = {
  34443: [
    {
      label: 'Official Mode Mainnet',
      value: ['https://mainnet.mode.network'],
    },
  ],
  1: [
    {
      label: 'Alchemy',
      value: ['https://eth-mainnet.g.alchemy.com/v2/RMfw-hu9MEpllxs59-ls_JP88YskBSnE'],
    },
    {
      label: 'Drpc',
      value: ['https://eth.drpc.org'],
    },
  ],
  10: [
    {
      label: 'Official Optimism Mainnet',
      value: ['https://mainnet.optimism.io'],
    },
  ],
};
